// Import your centralized Axios instance
import api from './api';

/*
 * Talks to the unified backend import routes:
 *   POST   /api/imports/:type/import   -> upsert a batch of rows
 *   DELETE /api/imports/:type          -> wipe that table for the company
 *
 * `urlType` is the slug from importConfig (e.g. 'gl-accounts', 'stock-codes',
 * 'cost-centers', 'sites').
 */
export const importService = {
  // Send formatted rows to the database for a given import type.
  // options.deactivateMissing -> soft refresh: rows not in the file are set
  //                              is_active = false instead of being deleted.
  importRecords: async (urlType, rows, options = {}) => {
    const response = await api.post(`/imports/${urlType}/import`, {
      rows, // backend also accepts `accounts` / `data` for backwards-compat
      deactivateMissing: options.deactivateMissing === true,
      // Full key list for chunked deactivate-refresh (sent on the final chunk).
      ...(Array.isArray(options.allKeys) ? { allKeys: options.allKeys } : {}),
    });
    return response.data;
  },

  // Delete all records for a given import type / company.
  // Pass force=true to cascade through dependent budget/actuals tables after
  // the user has confirmed the warning.
  deleteAllRecords: async (urlType, force = false) => {
    const response = await api.delete(`/imports/${urlType}`, {
      params: force ? { force: 'true' } : {},
    });
    return response.data;
  },
};

export default importService;